export default (...functions) => data => functions.reduce((value, func) => func(value), data);
